import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

const StyledSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
  },
  switchBase: {
    padding: 2,
    color: "#FF0000",
    "&$checked": {
      transform: "translateX(12px)",
      color: "#39811D",
      "& + $track": {
        opacity: 1,
        backgroundColor: "#ffffff",
        // borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    height: "auto",
    backgroundColor: theme.palette.common.white,
  },
  checked: {},
}))(Switch);

export default StyledSwitch;
